// we don't use an object to prevent to expose all origin paths, better for tree shaking
export const ORIGIN_UAT_API = 'https://dev-mtm.isaiastore.com/api';
export const ORIGIN_UAT_APP = 'https://dev-mtm.isaiastore.com';

export const ORIGIN_PROD_API = 'https://mtm.isaia.it/api';
export const ORIGIN_PROD_APP = 'https://mtm.isaia.it';

export const ORIGIN_LOCAL_API = 'https://api-mtm.isaia.lan/api';
export const ORIGIN_LOCAL_APP = 'http://localhost:4200';

export const ORIGIN_LAN_API = 'https://api-mtm.isaia.lan/api';
export const ORIGIN_LAN_APP = 'https://api-mtm.isaia.lan';
